import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { InitialFeedbackDataType } from '../../models/feedback/feedback.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';

import useHttps from '../useHttps';

const useSubmitInitialFeedback = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const onSubmitInitialFeedbackError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while sending feedback'
    );
  };

  const onSubmitInitialFeedbackSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    toast.success(`${message}, thank you for your feedback!`);
    sessionStorage.setItem('SIFP', 'false');
  };

  const submitInitialFeedback = async (data: InitialFeedbackDataType) => {
    sessionStorage.setItem('SMFP', 'false');
    sessionStorage.setItem('SIFP', 'false');

    const config: HttpConfig = {
      url: 'auth-service/feedback/initial',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    };

    request(
      config,
      onSubmitInitialFeedbackSuccess,
      setLoading,
      onSubmitInitialFeedbackError
    );
  };

  return { submitInitialFeedback, loading };
};

export default useSubmitInitialFeedback;
